import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StepService } from 'services/professional/step/step.service';
import { MessageQueryService } from '@certemy/ui-components';
import { DynamicFormInfo } from 'interfaces/dynamic-form-info.interface';
import { ComputedFrom } from '@certemy/common';
import { isStepSubmitted } from 'utils/step.helpers';
import { DynamicForm } from 'components/multiple-dynamic-form/multiple-dynamic-form.interface';
import { DynamicFormSection } from 'interfaces/dynamic-form-field.interface';
import { DynamicFormContentDetails } from '../dynamic-details/modal-content/dynamic-form-content-details/dynamic-form-content-details.component';
import { TestRegistrationInfoToSave, SubmitFormInterface } from './test-registration-details.constants';
import { VERIFICATION_TYPE } from 'constants/constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'cm-test-registration-details',
  styleUrls: ['./test-registration-details.modal.component.scss'],
  templateUrl: './test-registration-details.modal.component.html',
})
export class TestRegistrationDetailsComponent implements OnInit, OnDestroy {
  @Input() step;
  @Output() updateStep = new EventEmitter();

  formInfo: DynamicFormInfo;
  signature_link: string;
  sections: DynamicFormSection[];
  errorText: string;
  modalDetails: DynamicFormContentDetails;
  saveAsDraft = false;
  isSequentialFromStart = true;
  dynamicForms: DynamicForm[] = [];

  @ComputedFrom('step')
  get isStepSubmitted() {
    return isStepSubmitted(this.step.status_id);
  }

  constructor(
    public activeModal: NgbActiveModal,
    private stepService: StepService,
    private messageQueryService: MessageQueryService,
  ) {}

  ngOnInit() {
    this.modalDetails = {
      stepDescription: this.step.description,
    };

    const { signature_link, terms, sections, exams } = this.step.content;
    this.sections = sections;
    this.signature_link = signature_link;
    this.modalDetails.disclosureText = terms;

    if (!this.isStepSubmitted) {
      this.stepService
        .getDynamicFormData(this.step.step_id)
        .pipe(untilDestroyed(this))
        .subscribe((formInfo: DynamicFormInfo) => (this.formInfo = formInfo));
    }
  }

  ngOnDestroy() {}

  closeModal() {
    this.activeModal.close();
  }

  onFormSubmit(data: SubmitFormInterface) {
    const dataToSend: TestRegistrationInfoToSave = {
      specificTypePayload: {
        selectedExamId: data.selectedExamId,
        testRegistrationForm: {
          saveAsDraft: this.saveAsDraft,
          forms: [data.regFormData],
          id: this.step.step_instance_id,
          signature_link: data.signature.step,
        },
        useAda: data.useAda,
        ada: {
          saveAsDraft: this.saveAsDraft,
          forms: [data.adaFormData],
          id: this.step.step_instance_id,
          signature_link: data.signature.ada,
        },
        adaStepInstanceId: this.step.content.adaStepInstanceId,
        testRegistrationFormStepInstanceId: this.step.step_instance_id,
      },
      stepTypeId: this.step.step_type_id,
    };
    return this.stepService
      .submitStepWithSpecificTypePayload(this.step.step_instance_id, dataToSend)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.completeStep());
  }

  private completeStep() {
    const messageText = [
      VERIFICATION_TYPE.VERIFICATION_REQUIRED,
      VERIFICATION_TYPE.DOUBLE_VERIFICATION_REQUIRED,
    ].includes(this.step.verificationType)
      ? 'Step has been submitted for review'
      : 'Step has been successfully completed';
    this.messageQueryService.addMessage(messageText);
    this.closeModal();
  }
}
